module.exports = __webpack_public_path__ + "img/delete_database.9b98a0fc.svg";